// extracted by mini-css-extract-plugin
export var hidden = "section-module--hidden--9d6b2";
export var title = "section-module--title--03145";
export var wrapper = "section-module--wrapper--67610";